export const PAGE_MAX_WIDTH = '500px';
export const PAGE_MIN_HEIGHT = '100vh';
export const PAGE_BKG_COLOR = 'neutral.10';
export const PAGE_TITLE_COLOR = 'primary.50';
export const PAGE_MARGIN = '0 auto';
export const IMAGE_WIDTH = '100%';
